export const PatientLegal = {
  BANKRUPTCY: 'bankruptcy',
  CHILD_SUPPORT: 'child support',
  HIRED_ATTORNEY: 'hired attorney'
}
